import { EscrowMembershipRoleEnum } from 'src/graphql/schema';

export const roleOptions = [
  { label: 'Manager', value: EscrowMembershipRoleEnum.Manager },
  { label: 'Legal', value: EscrowMembershipRoleEnum.Legal },
  { label: 'Technical', value: EscrowMembershipRoleEnum.Technical },
  { label: 'Viewer', value: EscrowMembershipRoleEnum.Viewer },
];

export const roleOptionsDict = roleOptions.reduce(
  (acc, { value, label }) => ({ ...acc, [value]: label }),
  {},
) as Record<EscrowMembershipRoleEnum, string>;
